import { BordButton, BordModal, ModalContent } from 'bord-design-system';
import { IconWarning } from 'assets/DesignSystem/SVGComponents';

import './ConfirmActionModal.scss';

interface IConfirmActionModalProps {
  isOpen: boolean;
  modalText: string;
  firstButtonText: string;
  secondButtonText: string;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const ConfirmActionModal = ({
  isOpen,
  modalText,
  firstButtonText,
  secondButtonText,
  onClose,
  onConfirm,
  isLoading = false
}: IConfirmActionModalProps) => {
  if (!isOpen) return null;

  return (
    <BordModal
      closeModalCallback={onClose}
      closesOnClickOutside
      modalContent={
        <ModalContent
          excludeHeader
          excludeCloseButton
          customWidth="50rem"
          customHeight="auto"
          noPadding
          CustomModalComponent={
            <div className="confirmActionModalContent">
              <div className="confirmActionModalIconContainer">
                <IconWarning className="confirmActionModalWarningIcon" />
              </div>

              <p className="confirmActionModalText">{modalText}</p>

              <div className="confirmActionModalButtons">
                <BordButton
                  label={firstButtonText}
                  bordButtonStyle="outlined"
                  onClick={onClose}
                  disabled={isLoading}
                  customWidth='w-full'
                />
                <BordButton
                  label={secondButtonText}
                  onClick={onConfirm}
                  disabled={isLoading}
                  customWidth='w-full'
                />
              </div>
            </div>
          }
        />
      }
    />
  );
};

export default ConfirmActionModal;
